<template>
    <v-container fluid v-if="macchina">
        <v-btn icon variant="text" class="mb-2" @click="tornaIndietro">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-row>
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        {{ macchina.nome }}
                        <v-chip class="ml-3" size="small" :color="coloreStato(macchina.stato)" variant="flat">
                            {{ etichettaStato(macchina.stato) }}
                        </v-chip>
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" variant="text" prepend-icon="mdi-pencil"
                            @click="dialogModifica = true">
                            Modifica
                        </v-btn>
                    </v-card-title>
                    <v-card-subtitle>{{ macchina.repartoNome }}</v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6"><strong>Codice:</strong> {{ macchina.codice || '—' }}</v-col>
                            <v-col cols="6"><strong>N. serie:</strong> {{ macchina.numeroSerie || '—' }}</v-col>
                        </v-row>
                        <div class="mt-2" v-if="macchina.descrizione"><strong>Descrizione:</strong>
                            {{ macchina.descrizione }}</div>
                        <div class="mt-2" v-if="macchina.note"><strong>Note:</strong> {{ macchina.note }}</div>
                        <div class="mt-2" v-if="macchina.tempoMedioFermoMinuti != null">
                            <strong>Tempo medio di fermo:</strong>
                            {{ formattaDurataMinuti(macchina.tempoMedioFermoMinuti) }}
                        </div>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Manuali e documenti
                        <v-spacer />
                        <v-file-input v-model="fileManuale" label="Carica manuale (PDF)" accept="application/pdf"
                            density="compact" hide-details style="max-width: 260px" prepend-icon="mdi-upload"
                            @update:model-value="caricaManuale" />
                    </v-card-title>
                    <v-card-text>
                        <v-list v-if="macchina.allegati && macchina.allegati.length > 0">
                            <v-list-item v-for="a in macchina.allegati" :key="a.id" :title="a.nomeOriginale"
                                prepend-icon="mdi-file-pdf-box" />
                        </v-list>
                        <span v-else class="text-medium-emphasis">Nessun documento caricato.</span>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Manutenzioni
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="dialogNuova = true">
                            Nuova
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="m in manutenzioni" :key="m.id" :title="m.tipoManutenzioneNome"
                            :subtitle="descrizioneRiga(m)">
                            <template #prepend>
                                <v-chip size="small" :color="coloreStatoManutenzione(m)" variant="flat">
                                    {{ etichettaStatoManutenzione(m) }}
                                </v-chip>
                            </template>
                            <template #append v-if="puoScrivere">
                                <v-btn v-if="m.stato === 'Pianificata' && !m.richiedeFermoMacchina" size="small"
                                    variant="text" color="primary" @click="apriCompletamento(m.id)">
                                    Completa
                                </v-btn>
                                <v-btn v-else-if="m.stato === 'Pianificata' && m.richiedeFermoMacchina" size="small"
                                    variant="text" color="orange-darken-2" @click="iniziaManutenzione(m.id)">
                                    Inizia
                                </v-btn>
                                <v-btn v-else-if="m.stato === 'InCorso'" size="small" variant="text" color="primary"
                                    @click="apriCompletamento(m.id)">
                                    Completa
                                </v-btn>
                                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(m)">
                                    <v-icon size="small">mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error" @click="chiediEliminazione(m)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="manutenzioni.length === 0">
                            <span class="text-medium-emphasis">Nessuna manutenzione registrata.</span>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>QR code</v-card-title>
                    <v-card-text class="text-center">
                        <div id="area-stampa-qr">
                            <canvas ref="qrCanvas"></canvas>
                            <div class="mt-2 text-caption text-medium-emphasis">Se non riesci a scansionare,
                                copia il link:</div>
                            <div class="text-body-2">{{ urlPubblico }}</div>
                        </div>
                        <v-btn class="mt-3" variant="outlined" prepend-icon="mdi-printer" @click="stampa">
                            Stampa
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <dialog-macchina v-model="dialogModifica" :macchina="macchina" @salvato="carica" />

        <dialog-nuova-manutenzione v-model="dialogNuova" :macchina-id="id" @salvato="ricaricaManutenzioni" />

        <dialog-completa-manutenzione v-model="dialogCompletamento" :manutenzione-id="manutenzioneSelezionataId"
            :macchina-id="id" @completata="onManutenzioneAggiornata" />

        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>
                    <div v-if="manutenzioneDaEliminare && manutenzioneDaEliminare.stato === 'Completata'">
                        Questa manutenzione è già completata. Vuoi rimettere a magazzino i ricambi consumati?
                        <v-radio-group v-model="ripristinaMagazzino" class="mt-2">
                            <v-radio label="Sì, ripristina i materiali" :value="true" />
                            <v-radio label="No, sono stati comunque consumati" :value="false" />
                        </v-radio-group>
                    </div>
                    <div v-else>La manutenzione pianificata verrà rimossa.</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
import QRCode from "qrcode";
import { upload_allegato_macchina } from "@/api/api.allegati.js";
import DialogNuovaManutenzione from "@/components/manutenzione/DialogNuovaManutenzione.vue";
import DialogCompletaManutenzione from "@/components/manutenzione/DialogCompletaManutenzione.vue";
import DialogMacchina from "@/components/macchine/DialogMacchina.vue";
import { coloreStato, etichettaStato } from "@/constants/statoMacchina.js";
import {
    coloreStatoManutenzione as coloreStatoManutenzioneBase,
    etichettaStatoManutenzione as etichettaStatoManutenzioneBase,
} from "@/constants/statoManutenzione.js";
import Functions from "@/utils/functions.js";

export default {
    name: "MacchinaDettaglioPage",

    components: {
        DialogNuovaManutenzione,
        DialogCompletaManutenzione,
        DialogMacchina,
    },

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            fileManuale: null,
            dialogNuova: false,
            dialogCompletamento: false,
            dialogModifica: false,
            manutenzioneSelezionataId: null,
            dialogElimina: false,
            manutenzioneDaEliminare: null,
            ripristinaMagazzino: false,
        };
    },

    computed: {
        macchina() {
            return this.$store.getters["macchine/corrente"];
        },
        manutenzioni() {
            return this.$store.getters["manutenzioni/lista"];
        },
        ruolo() {
            return this.$store.getters["user/getRole"];
        },
        puoScrivere() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
        },
        urlPubblico() {
            return `${window.location.origin}/macchine/${this.id}`;
        },
    },

    watch: {
        id: {
            immediate: true,
            handler() {
                this.carica();
            },
        },
    },

    methods: {
        tornaIndietro() {
            this.$router.push("/macchine");
        },

        async carica() {
            try {
                await this.$store.dispatch("macchine/caricaDettaglio", this.id);
                await this.ricaricaManutenzioni();
                await this.$nextTick();
                this.generaQr();
            } catch (error) {
                console.log(error);
            }
        },

        ricaricaManutenzioni() {
            return this.$store.dispatch("manutenzioni/carica", { macchinaId: this.id });
        },

        generaQr() {
            if (!this.$refs.qrCanvas) return;
            QRCode.toCanvas(this.$refs.qrCanvas, this.urlPubblico, { width: 220 }, (err) => {
                if (err) console.log(err);
            });
        },

        stampa() {
            window.print();
        },

        async caricaManuale(file) {
            if (!file) return;
            try {
                await upload_allegato_macchina(this.id, file);
                await this.$store.dispatch("macchine/caricaDettaglio", this.id);
                this.fileManuale = null;
            } catch (error) {
                console.log(error);
            }
        },

        apriCompletamento(manutenzioneId) {
            this.manutenzioneSelezionataId = manutenzioneId;
            this.dialogCompletamento = true;
        },

        async iniziaManutenzione(manutenzioneId) {
            try {
                await this.$store.dispatch("manutenzioni/inizia", { id: manutenzioneId, macchinaId: this.id });
                // Il backend porta la macchina in "In manutenzione": ricarico anche il
                // suo dettaglio, non solo la lista manutenzioni, per riflettere il chip di stato.
                await this.$store.dispatch("macchine/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
        },

        // Usato sia da "salvato" (nuova manutenzione) sia da "completata": una
        // manutenzione completata puo' riportare la macchina ad "Attiva", quindi
        // ricarico anche il dettaglio macchina oltre alla lista manutenzioni.
        async onManutenzioneAggiornata() {
            await this.ricaricaManutenzioni();
            await this.$store.dispatch("macchine/caricaDettaglio", this.id);
        },

        async duplica(m) {
            try {
                await this.$store.dispatch("manutenzioni/duplica", { id: m.id, macchinaId: this.id });
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(m) {
            this.manutenzioneDaEliminare = m;
            this.ripristinaMagazzino = false;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("manutenzioni/elimina", {
                    id: this.manutenzioneDaEliminare.id,
                    ripristinaMagazzino: this.ripristinaMagazzino,
                    macchinaId: this.id,
                });
                // Annullare una manutenzione InCorso puo' riportare la macchina ad
                // Attiva lato backend: ricarico anche il dettaglio macchina.
                await this.$store.dispatch("macchine/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
            this.dialogElimina = false;
        },

        coloreStato,
        etichettaStato,

        coloreStatoManutenzione(m) {
            if (m.stato === "Pianificata" && m.effettivamenteScaduta) return "error";
            if (m.stato === "Pianificata" && m.previstaOggi) return "warning";
            return coloreStatoManutenzioneBase(m.stato);
        },
        etichettaStatoManutenzione(m) {
            if (m.stato === "Pianificata" && m.effettivamenteScaduta) return "Scaduta";
            if (m.stato === "Pianificata" && m.previstaOggi) return "Prevista oggi";
            return etichettaStatoManutenzioneBase(m.stato);
        },
        descrizioneRiga(m) {
            const data = m.stato === "Completata" ? m.dataCompletamento : m.dataPrevista;
            let riga = data ? new Date(data).toLocaleDateString("it-IT") : "";
            if (m.stato === "Completata" && m.richiedeFermoMacchina && m.dataInizio && m.dataCompletamento) {
                const minuti = (new Date(m.dataCompletamento) - new Date(m.dataInizio)) / 60000;
                riga += ` · Fermo: ${this.formattaDurataMinuti(minuti)}`;
            }
            return riga;
        },
        formattaDurataMinuti: Functions.formattaDurataMinuti,
    },
};
</script>